import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/activity/ActivityLoader.module_built.css";
const classes = {"activity-loader":"wnVy-QG_activity-loader","variant-fluent":"wnVy-QG_variant-fluent","variant-copilot":"wnVy-QG_variant-copilot"}
export default classes

const _activity_loader0 = classes["activity-loader"]
export { _activity_loader0 as "activity-loader" }

const _variant_fluent0 = classes["variant-fluent"]
export { _variant_fluent0 as "variant-fluent" }

const _variant_copilot0 = classes["variant-copilot"]
export { _variant_copilot0 as "variant-copilot" }
